import { CircularProgress, FormHelperText, Icon, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { FormControl } from './index';
import { green } from '@mui/material/colors';
import axiosInstance from 'src/utils/axios';
import PropTypes from "prop-types";

const FileBox = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [error, setError] = React.useState('');

  const { name, label, accept, icon, value, required, inputAdornmentPosition, fullWidth, helperText, disabled } = props;

  const fileUpload = async (e) => {
    let file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    setLoading(true);

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    };

    await axiosInstance.post(`/${props.url}`, formData, config).then((response) => {
      const { data } = response;
      if (response.status === 200) {
        setLoading(false);
        setMessage(data.message);
        props.onChange(data.url);
      } else {
        setLoading(false);
        setError(data.message);
      }
    }).catch((error) => {
      const { response } = error
      setLoading(false);
      setError(response.data.message);
    })
  };

  const refId = `${name}-document-file`;

  return (
    <React.Fragment>
      <input
        style={{ display: 'none' }}
        id={refId}
        type="file"
        accept={accept}
        onChange={(e) => {
          fileUpload(e);
          e.target.value = null;
        }}
      />

      <FormControl
        key={`key${name}`}
        error={helperText ? true : false}
        fullWidth={fullWidth}
        required={required}
      >
        <TextField
          error={(helperText || error) ? true : false}
          success={error ? false : true}
          name={name}
          label={label}
          type='url'
          readOnly={disabled}
          required={required}
          disabled={disabled}
          value={value}
          onChange={e => props.onChange(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position={inputAdornmentPosition}>
                {loading && <CircularProgress size={25} />}
                <label htmlFor={refId}>
                  {!loading && <Icon>{icon}</Icon>}
                </label>
              </InputAdornment>
            )
          }}
        />

        {helperText && <FormHelperText>{helperText}</FormHelperText>}
        {error && <FormHelperText>{error}</FormHelperText>}
        {message && <FormHelperText style={{ color: green[500] }}>{message}</FormHelperText>}
      </FormControl>
    </React.Fragment>
  );
};

FileBox.defaultProps = {
  accept: 'image/*',
  icon: 'image',
  inputAdornmentPosition: 'end',
  fullWidth: true,
  required: false,
  disabled: false,
  url: 'admin/upload/image'
};

FileBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  accept: PropTypes.string,
  icon: PropTypes.string,
  value: PropTypes.string,
  required: PropTypes.bool,
  inputAdornmentPosition: PropTypes.string,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  url: PropTypes.string
};

export default FileBox;